import styled from '@emotion/styled';

/**
 * Один отступ на всё: от шапки до первого блока (`padding-top`), между рядами (`gap`), между карточками ряда
 * и от последнего ряда до низа страницы. Раньше было 24 / 20 / 10 / 0 — блоки стояли на разном расстоянии.
 */
const PAGE_SPACING = '24px';

export const MainBlock = styled.div`
  padding: ${PAGE_SPACING};

  display: flex;
  flex-direction: column;
  gap: ${PAGE_SPACING};
`;

export const SectionsWrapper = styled.div`
  display: flex;
  gap: ${PAGE_SPACING};

  /* Карточки делят ряд поровну (не меньше своего min-width) — свободное место не растягивает зазор. */
  & > * {
    flex: 1 1 0;
  }

  overflow-x: auto;
`;
